import React from 'react';
import { Card, Divider, Typography } from '@mui/material';

import { useStripeConnect } from '../store/hooks';

import { StripeInvoicesTable } from './StripeInvoicesTable';

/**
 * Card wrapper for StripeInvoicesTable that handles conditional rendering
 * based on Stripe connection status. Returns null if Stripe is not connected.
 */
export const StripeInvoicesTableCard: React.FC = () => {
  const { hasStripeAccount } = useStripeConnect();

  // Don't render anything if Stripe is not connected
  if (!hasStripeAccount) {
    return null;
  }

  return (
    <Card variant="outlined" sx={{ p: 3 }}>
      <Typography variant="h6" gutterBottom>
        Invoices
      </Typography>
      <Divider sx={{ mb: 2 }} />
      <StripeInvoicesTable />
    </Card>
  );
};
